import React, {Component} from 'react';
import {connect} from 'react-redux';
 import {bindActionCreators} from 'redux';
import queryString from 'query-string'
import {makeRequest,dispatchAction,displayMessage}  from 'actions';
import {FETCH_SELLERS, DELETE_SELLER,REMOVE_SELECTED_SELLERS,
    ADD_SELECTED_SELLERS,CLEAR_SELECTED_SELLERS} from "actions/actionTypes";
import AdminSellersSearchBox from 'dashboard/sellers/AdminSellersSearchBox'
import AdminSellersActionsBox from 'dashboard/sellers/AdminSellersActionsBox'
import config from  '../../../config';
 import AdminSellerListTable from'dashboard/sellers/AdminSellerListTable';
import PaginationBox from'shared/PaginationBox';

class AdminSellersPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    constructor(props, context) {
        super(props, context);
        var queryParams = queryString.parse(this.props.location.search);
        this.state = {
           sortBy:  _.get(queryParams, 'sortBy', 'DisplayName:1'),
            currentPage: queryParams.page ?  parseInt(queryParams.page) -1 : 0,
          selectAllRecords:false,
         };
        this.searchBox = false;
    };

    onSortChange(field, sortOrder){
         this.setState({sortBy: field + ':' + (sortOrder ==  'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }
    search(params = {}) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
        var {queryParams} = this.searchBox.getSearchParams();
        console.log('queryParams', queryParams  );
        _.extend(queryParams, params);
         if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
             queryParams.sortBySecondary  = '_id:-1'; /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
         }
        if (queryParams.page ==1) {
            queryParams.page = undefined;
        }
         const stringified = queryString.stringify(_.omit(queryParams,['include', 'lookup', 'all','sortBySecondary']));
        this.context.router.push('/admin/sellers?' + stringified);
        var methodData = {
            "endpoint": "/sellers",
            'not_display_success_message': true
        };
        if (_.isUndefined(params.page)) { /* do not clear selected transactions when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_SELLERS)
        }
        queryParams.addFields = [
           //  'ServicesTotalNumber','DropoffsTotalNumber','FirstServiceDate', 'LastServiceDate',   'PickupsTotalNumber',
         //  'ProductsTotalNumber',
            //'ProductsTotalSum',
           //'SaleTransactionsTotalNumber', 'SellerTotalMade'
        ]
     //   queryParams.addFields = []
        if (_.isUndefined(params.include)  ) {
            methodData['success_event'] = FETCH_SELLERS;
        }
        return this.props.makeRequest(queryParams, methodData).then((res)=>{
            this.setState({pending:false})
            return res
        }).catch(err => {
            this.setState({pending:false})
            return Promise.reject(err)
        });
    }

    toggleAllRecordsSelection(value) {
        if (value) {
            this.setState({ selectAllRecords:true});
        }else{
            this.setState({ selectAllRecords:false});
        }
    }

    render() {

        return (
            <div >
                {config.checkAccessRights.call(this,{ resources:['sellers_full']}) &&
                <AdminSellersActionsBox     {...this.props} ></AdminSellersActionsBox>
                }
                <AdminSellersSearchBox  pending={this.state.pending}   ref={(searchBox) => {
                    if (searchBox && !this.searchBox) {
                        this.searchBox = searchBox;
                        if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ) { /* by default search only if recordIDs are passed*/
                            this.search({page:this.state.currentPage+1})
                        }
                    }
                } }
                                    search={this.search.bind(this)}  selectAllRecords = {this.state.selectAllRecords} toggleAllRecordsSelection = {this.toggleAllRecordsSelection.bind(this)}     {...this.props} ></AdminSellersSearchBox>
                {(this.props.adminSellers.total !== 'initial' &&  this.props.adminSellers.total == 0) ?
                    <div className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'Sellers')}</div> :
                    <div className="top20">
                        <AdminSellerListTable
                            search={this.search.bind(this)}  onSortChange={this.onSortChange.bind(this)} {...this.props}   ></AdminSellerListTable>
                        <PaginationBox
                            ref={'pagination'}
                            currentPage={this.state.currentPage}
                            perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : undefined}
                            total={this.props.adminSellers.total == 'initial' ? 0 : this.props.adminSellers.total}
                            search={this.search.bind(this)} >
                        </PaginationBox>
                    </div>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        'adminSellers': state.adminSellers,
        userReducer:state.userReducer
    };

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest,dispatchAction,displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSellersPage);
